import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../../../models';
import { Cliente } from '../../cliente';
import { Representante } from '../../../representante';
import { Cidade } from '../../../../cidade';

export class ClienteInternetFilter implements Filter {
    codigoIntegracaoErp: string;
    cnpjCpf: string;
    cadastros: number[] = [];
    situacao: number;
    idCliente: number;
    cliente: Cliente;
    idRepresentante: number;
    representante: Representante;
    ecommerce: boolean;
    mercadoLivre: boolean;
    marketplace: boolean;
    nomeEcommerce: string;
    idCidade: number;
    cidade: Cidade;
    idEstado: number;

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Código Integração ERP
        if (this.codigoIntegracaoErp && this.codigoIntegracaoErp.trim().length > 0) {
            params = params.append('codigoIntegracaoErp', this.codigoIntegracaoErp);
        }
        // CNPJ/CPF
        if (this.cnpjCpf && this.cnpjCpf.trim().length > 0) {
            params = params.append('cnpjCpf', this.cnpjCpf);
        }
        // Cadastros
        this.cadastros?.forEach(cadastro => {
            params = params.append('cadastro', cadastro ? cadastro.toString() : null);
        });
        // Situação
        // if (this.situacao) {
        //     params = params.append('situacao', this.situacao.toString());
        // }
        // Cliente
        if (this.idCliente) {
            params = params.append('idCliente', this.idCliente.toString());
        }
        // Representante
        if (this.idRepresentante) {
            params = params.append('idRepresentante', this.idRepresentante.toString());
        }
        // E-commerce
        if (this.ecommerce) {
            params = params.append('ecommerce', this.ecommerce.toString());
        }
        // Mercado Livre
        if (this.mercadoLivre) {
            params = params.append('mercadoLivre', this.mercadoLivre.toString());
        }
        // Marketplace
        if (this.marketplace) {
            params = params.append('marketplace', this.marketplace.toString());
        }
        // Nome E-commerce
        if (this.nomeEcommerce) {
            params = params.append('nomeEcommerce', this.nomeEcommerce);
        }
        // Cidade
        if (this.idCidade) {
            params = params.append('idCidade', this.idCidade.toString());
        }
        // Estado
        if (this.idEstado) {
            params = params.append('idEstado', this.idEstado.toString());
        }

        return params;
    }

    clear() {
        this.codigoIntegracaoErp = null;
        this.cnpjCpf = null;
        this.cadastros = [];
        this.situacao = null;
        this.idCliente = null;
        this.cliente = null;
        this.idRepresentante = null;
        this.representante = null;
        this.ecommerce = null;
        this.mercadoLivre = null;
        this.marketplace = null;
        this.nomeEcommerce = null;
        this.idCidade = null;
        this.cidade = null;
        this.idEstado = null;
    }
}

